"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _WalletButtonsTransactions = _interopRequireDefault(require("./WalletButtonsTransactions"));

var _WalletButtonsDepositLimit = _interopRequireDefault(require("./WalletButtonsDepositLimit"));

var _WalletButtonsWithdraw = _interopRequireDefault(require("./WalletButtonsWithdraw"));

var _WalletButtonsDeposit = _interopRequireDefault(require("./WalletButtonsDeposit"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  overflow: hidden;\n  ", ";\n"])), function (props) {
  return !props.isActive && "max-height: 56px";
});

var StyledIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (props) {
  return props.theme.colorLabel;
});

var StyledText = _styledComponents.default.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-left: 1rem;\n  font-size: 0.875rem;\n"])));

var sharedStyles = (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  font-family: ", ";\n  color: ", ";\n  width: 100%;\n  height: 56px;\n  padding: 0 1rem;\n"])), function (p) {
  return p.theme.fontFamilyDefault;
}, function (p) {
  return p.theme.colorText;
});

var StyledButton = _styledComponents.default.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n"])), sharedStyles);

var StyledAnchor = _styledComponents.default.a(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  ", ";\n"])), sharedStyles);

var StyledDisabledButton = _styledComponents.default.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  cursor: not-allowed;\n\n  & > ", " {\n    color: ", ";\n  }\n"])), sharedStyles, function (p) {
  return (0, _polished.rgba)(p.theme.colorDisabledText, 0.55);
}, StyledIcon, function (p) {
  return (0, _polished.rgba)(p.theme.colorDisabledText, 0.55);
});

var StyledDisabledMessage = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  padding: 0 2rem;\n  font-size: 0.875rem;\n  color: ", ";\n  margin-bottom: 1rem;\n  line-height: 1.5;\n\n  & a {\n    color: inherit;\n    font-size: inherit;\n    text-decoration: underline;\n  }\n"])), function (p) {
  return p.theme.colorLabel;
});

var StyledContent = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  padding: 0 2rem 1rem;\n  border-bottom: 2px solid ", ";\n"])), function (props) {
  return props.theme.colorBorder;
});

var WalletButtons = function WalletButtons(_ref) {
  var walletLoading = _ref.walletLoading,
      addCardUrl = _ref.addCardUrl,
      addCardError = _ref.addCardError,
      isIframe = _ref.isIframe,
      dateLocale = _ref.dateLocale,
      hideGamblingReferences = _ref.hideGamblingReferences,
      hideTransactions = _ref.hideTransactions,
      translations = _ref.translations,
      transactionsUpdated = _ref.transactionsUpdated,
      setTransactionsUpdated = _ref.setTransactionsUpdated,
      onError = _ref.onError,
      getWallet = _ref.getWallet,
      currencySymbol = _ref.currencySymbol,
      balance = _ref.balance,
      depositLimit = _ref.depositLimit,
      depositLimitToShow = _ref.depositLimitToShow,
      hasPendingLimit = _ref.hasPendingLimit,
      isLoading = _ref.isLoading,
      errorMessage = _ref.errorMessage,
      setPromoCode = _ref.setPromoCode,
      activeButton = _ref.activeButton,
      toggleActive = _ref.toggleActive,
      transactions = _ref.transactions,
      transactionsTotal = _ref.transactionsTotal,
      loadMoreTransactions = _ref.loadMoreTransactions,
      isPhoneNumberVerified = _ref.isPhoneNumberVerified,
      cardAdded = _ref.cardAdded;
  return /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, {
    padding: "1rem 0"
  }, /*#__PURE__*/_react.default.createElement(StyledRow, {
    isActive: true
  }, addCardUrl && /*#__PURE__*/_react.default.createElement(StyledAnchor, {
    href: addCardUrl,
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "credit_card"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.addCard)), !addCardUrl && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledDisabledButton, null, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "credit_card"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.addCard)), !walletLoading && addCardError && /*#__PURE__*/_react.default.createElement(StyledDisabledMessage, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Alert, {
    isDanger: true,
    textAlign: "left"
  }, addCardError)))), /*#__PURE__*/_react.default.createElement(StyledRow, {
    isActive: activeButton === 3 || !cardAdded,
    onClick: function onClick() {
      return toggleActive(3);
    }
  }, !cardAdded && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledDisabledButton, null, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "keyboard_return"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.withdraw)), !walletLoading && /*#__PURE__*/_react.default.createElement(StyledDisabledMessage, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Alert, {
    isDanger: true,
    textAlign: "left"
  }, translations.addCardToWithdraw))), cardAdded && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledButton, null, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "keyboard_return"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.withdraw)), /*#__PURE__*/_react.default.createElement(StyledContent, {
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_WalletButtonsWithdraw.default, {
    setTransactionsUpdated: setTransactionsUpdated,
    currencySymbol: currencySymbol,
    translations: translations,
    onError: onError,
    getWallet: getWallet,
    balance: balance
  })))), /*#__PURE__*/_react.default.createElement(StyledRow, {
    isActive: activeButton === 6 || !cardAdded,
    onClick: function onClick() {
      return toggleActive(6);
    }
  }, !cardAdded && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledDisabledButton, null, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "library_add"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.deposit)), !walletLoading && /*#__PURE__*/_react.default.createElement(StyledDisabledMessage, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Alert, {
    isDanger: true,
    textAlign: "left"
  }, translations.addCardToDeposit))), cardAdded && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(StyledButton, null, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "library_add"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.deposit)), /*#__PURE__*/_react.default.createElement(StyledContent, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_WalletButtonsDeposit.default, {
    setTransactionsUpdated: setTransactionsUpdated,
    currencySymbol: currencySymbol,
    translations: translations,
    onError: onError,
    getWallet: getWallet,
    balance: balance
  })))), !hideTransactions && /*#__PURE__*/_react.default.createElement(StyledRow, {
    isActive: activeButton === 4,
    onClick: function onClick() {
      window.xtremepush("tag", "Wallet.Transactions", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));
      toggleActive(4);
    }
  }, /*#__PURE__*/_react.default.createElement(StyledButton, null, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "receipt_long"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.transactions)), /*#__PURE__*/_react.default.createElement(StyledContent, {
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_WalletButtonsTransactions.default, {
    onError: onError,
    dateLocale: dateLocale,
    translations: translations,
    currencySymbol: currencySymbol,
    transactionsUpdated: transactionsUpdated,
    setTransactionsUpdated: setTransactionsUpdated
  }))), !hideGamblingReferences && /*#__PURE__*/_react.default.createElement(StyledRow, {
    isActive: activeButton === 5,
    onClick: function onClick() {
      window.xtremepush("tag", "Wallet.DepositLimit", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));
      toggleActive(5);
    }
  }, /*#__PURE__*/_react.default.createElement(StyledButton, null, /*#__PURE__*/_react.default.createElement(StyledIcon, null, "app_blocking"), /*#__PURE__*/_react.default.createElement(StyledText, null, translations.depositLimit)), /*#__PURE__*/_react.default.createElement(StyledContent, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, /*#__PURE__*/_react.default.createElement(_WalletButtonsDepositLimit.default, {
    onError: onError,
    translations: translations,
    errorMessage: errorMessage,
    currencySymbol: currencySymbol,
    dateLocale: dateLocale
  }))));
};

var _default = WalletButtons;
exports.default = _default;